module.exports = __webpack_public_path__ + "img/typing.750453a0.jpg";